export default Object.freeze({
  Ok: { value: 0, css: 'ok' },
  Warning: { value: 1, css: 'warning' },
  Error: { value: 2, css: 'error' },

  isMoreSevere: function (enum1, enum2) {
    return enum1.value > enum2.value;
  },

  mostSevere: function (enum1, enum2) {
    return this.isMoreSevere(enum1, enum2) ? enum1 : enum2;
  },
});



// WEBPACK FOOTER //
// ./src/common/PartAlertLevel.js